// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d6083adc","849":"4d4d2daa"}[chunkId] + ".chunk.js";
};